<template>
  <div class="view-contanier">
    <div class="header">
      <div class="tab">
        <span
          v-permissson="'QT'"
          class="tabItem"
          :class="{ active: active === 0 }"
          @click="changeType(0, 'QT')"
        >清提</span
        >
        <span
          v-permissson="'QTYW'"
          class="tabItem"
          :class="{ active: active === 1 }"
          @click="changeType(1, 'QTYW')"
        >其他业务</span
        >
      </div>
      <div class="opt">
        <div v-if="filterList.date && isActive" class="checkDate flex_c_c">
          查询时间：{{ filterList.date[0] + "~" + filterList.date[1] }}
        </div>
        <div class="search">
          <el-popover
            ref="popover"
            placement="top"
            class="searchPop"
            title="批量搜索"
            trigger="click"
            width="378"
          >
            <div class="close-pop" @click="closeSearchPanel">
              <i class="el-icon-close"></i>
            </div>
            <base-muti-input
              ref="baseMutiInput"
              v-model="referenceNumber"
            ></base-muti-input>
            <div style="text-align: right; margin: 16px 0 0">
              <el-button size="small" @click="handleEmpty">清空</el-button>
              <div class="sure" @mousedown="handleConfirm">确定</div>
            </div>
          </el-popover>
          <el-input
            :value="searchVal"
            placeholder="请输入提单号搜索"
            class="input-search"
            @focus="handleFocus"
          ></el-input>
          <div class="btn-search" @click="handleConfirm">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <div
          v-show="computedPermissions('导出')"
          :v-permissson="computedPermissions('导出')"
          class="upload flex_c_c"
          @click="exportListFile()"
        >
          <img src="@/assets/images/const/derive.png" alt="" />
          导出
        </div>
        <el-tooltip
          v-show="computedPermissions('关账')"
          :v-permissson="computedPermissions('关账')"
          class="item"
          effect="dark"
          content="只能关闭已核销的数据!"
          placement="right"
        >
          <div class="close flex_c_c" @click="dialogVisible2 = true">
            <img src="@/assets/images/const/closeBill.png" alt="" />
            关账
          </div>
        </el-tooltip>
        <div
          v-show="active === 1"
          v-permissson="'closeMoney'"
          class="close flex_c_c"
          @click="dialogVisible5 = true"
        >
          <img src="@/assets/images/const/closeMoney.png" alt="" />
          结账
        </div>
        <BaseFilter
          :isActive="isActive"
          :width="466"
          @sendFilter="sendFilter"
          @reset="reset"
        >
          <div class="filter">
            <el-form ref="form" :model="filterList" label-width="68px">
              <el-form-item :label="active ? '创建日期' : 'ETA'">
                <el-date-picker
                  v-model="filterList.date"
                  style="width: 320px"
                  type="daterange"
                  range-separator="至"
                  align="center"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item v-if="active === 0" label="审核日期">
                <el-date-picker
                  v-model="filterList.reviewDate"
                  style="width: 320px"
                  type="daterange"
                  range-separator="至"
                  align="center"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="客户">
                <el-select
                  v-model="filterList.companyId"
                  style="width: 320px"
                  filterable
                  placeholder="请选择客户"
                >
                  <el-option
                    v-for="item in companyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="active === 0" label="关账">
                <el-select
                  v-model="filterList.closeType"
                  style="width: 320px"
                  filterable
                  placeholder="请选择是否关联"
                >
                  <el-option
                    v-for="item in closeTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="active === 1" label="关账">
                <el-select
                  v-model="filterList.closingAccountStatus"
                  style="width: 320px"
                  filterable
                  placeholder="请选择是否关联"
                >
                  <el-option
                    v-for="item in closeTypeOptions1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="关账号码">
                <base-muti-input
                  ref="baseMutiInput1"
                  v-model="filterList.closeNo"
                  style="width: 320px"
                ></base-muti-input>
              </el-form-item>
              <!-- <el-form-item v-if="active === 0" label="关账类型">
                <el-select
                  v-model="filterList.closeType"
                  style="width: 320px"
                  filterable
                  placeholder="请选择是否关联"
                >
                  <el-option
                    v-for="item in closeTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->
            </el-form>
          </div>
        </BaseFilter>
      </div>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :key="active"
        :height="height"
        :tableData="{
          ...tableData,
          fileds,
        }"
        :loading="loading"
        :pageIndex="pagerConfig.pageIndex"
        :pageSize="pagerConfig.pageSize"
        :isEmptyBorder="true"
        @handleSelectionChange="handleSelectionChange"
        @handlePageChange="handlePageChange"
        @sortChange="sortChange"
        @dblclick="showBillingDetail"
      >
        <template slot="opt" slot-scope="row">
          <el-popover
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <el-button
                  v-if="active === 0"
                  v-permissson="'detail'"
                  class="opt-item"
                  @click="showBillingDetail(row.scope)"
                >明细</el-button
                >
              </div>
            </div>
            <img
              slot="reference"
              style="margin-left: -14px"
              src="@/assets/images/table/opt.png"
            />
          </el-popover>
          <!-- <div class="table-opt">
            <span
              v-if="active === 0"
              v-permissson="'detail'"
              @click="showBillingDetail(row.scope)"
            >明细</span
            >
          </div> -->
        </template>
        <template slot="closeType" slot-scope="row">
          <span class="tips" :style="formatterColor(row.scope.closeType)">
            {{ row.scope.closeType | formatter }}
          </span>
        </template>
        <template slot="closingAccountStatus" slot-scope="row">
          <span
            :class="[
              'tips',
              `closingAccountStatus${row.scope.closingAccountStatus}`,
            ]"
          >
            {{ !row.scope.closingAccountStatus ? "未关账" : "已关账" }}
          </span>
        </template>
        <template slot="grossProfit" slot-scope="row">
          <span :style="{ color: row.scope.grossProfit > 0 ? '' : '#fe453d' }">
            {{ row.scope.grossProfit }}
          </span>
        </template>
        <template slot="totalPayable" slot-scope="row">
          <span>
            {{ row.scope.totalPayable }}
            <img
              class="icon"
              src="@/assets/images/order/cut.png"
              @click="psDetail(row.scope)"
            />
          </span>
        </template>
        <div slot="otherServiceType" slot-scope="row" class="otherServiceType">
          <div class="type-item flex_c_c">
            {{ row.scope.otherServiceTypes }}
          </div>
        </div>
        <template #custom-total>
          <div v-if="active === 0" class="custom-total">
            <div style="display: flex">
              <div class="total">
                应付总计：<span>{{ total.totalPayableAmount }} USD</span>
                &nbsp;&nbsp;应付关税总计：<span
                >{{ total.totalPayableTariffAmount }} USD</span
                >
                &nbsp;&nbsp;应收总计：<span
                >{{ total.totalReceivableAmount }} USD</span
                >
                &nbsp;&nbsp;应收关税总计：<span
                >{{ total.totalReceivableTariffAmount }} USD</span
                >
                &nbsp;&nbsp;毛利总计：<span
                >{{ total.totalGrossProfitAmount }} USD</span
                >
              </div>
            </div>
          </div>
        </template>
      </BaseTable>
    </div>
    <!-- <div class="footer">
      <div class="selection">已选 {{ selection.length }} 项</div>
      <div class="sum">
        <span class="sum-item">
          <span
          >应收总额：<span class="price">{{
            !active ? sumReceivableAmount : `${total.totalReceivableAmount} ${total.currency}`
          }}</span></span
          >
        </span>
        <span class="sum-item">
          <span
          >应付总额：<span class="price">{{
            !active ? sumPayableAmount : `${total.totalPayableAmount} ${total.currency}`
          }}</span></span
          >
        </span>
        <span class="sum-item">
          <span
          >毛利总计：<span class="price">{{
            !active ? sumgrossProfit : `${total.totalGrossProfitAmount} ${total.currency}`
          }}</span></span
          >
        </span>
      </div>
    </div> -->
    <GrossProfitQTDialog
      :dialogVisible="dialogVisible"
      :containerNumber="rowData.containerNumber"
      :filter="{
        startDate:
          filterList.date && filterList.date.length > 0
            ? filterList.date[0]
            : '',
        endDate:
          filterList.date && filterList.date.length > 0
            ? filterList.date[1]
            : '',
        id: rowData.mblId,
      }"
      @ok="dialogVisible = false"
    >
    </GrossProfitQTDialog>
    <CloseBillDialog
      :dialogVisible="dialogVisible2"
      :active="active"
      @ok="dialogVisible2 = false; initList()"
      @cancel="dialogVisible2 = false"
    >
    </CloseBillDialog>
    <GrossProfitPSDialog
      :dialogVisible="dialogVisible3"
      :filter="{
        startDate:
          filterList.date && filterList.date.length > 0
            ? filterList.date[0]
            : '',
        endDate:
          filterList.date && filterList.date.length > 0
            ? filterList.date[1]
            : '',
        id: rowData.orderId,
      }"
      @cancel="dialogVisible3 = false"
    >
    </GrossProfitPSDialog>
    <GrossProfitFileDialog
      :dialogVisible="dialogVisible4"
      :filter="{
        ...formatterFilter(),
        needPaged: false,
      }"
      :type="active"
      @cancel="dialogVisible4 = false"
    >
    </GrossProfitFileDialog>
    <CheckoutDialog
      :dialogVisible="dialogVisible5"
      @ok="dialogVisible5 = false"
      @cancel="dialogVisible5 = false"
    >
    </CheckoutDialog>
    <OtherBusDialog
      :dialogVisible="dialogVisible6"
      :active="active"
      :otherServiceId="rowData.id"
      @ok="dialogVisible6 = false"
    >
    </OtherBusDialog>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const BaseFilter = () => import('@/components/filter/BaseFilter')
import GrossProfitQTDialog from './components/GrossProfitQTDialog.vue'
import CloseBillDialog from './components/CloseBillDialog.vue'
import GrossProfitPSDialog from './components/GrossProfitPSDialog.vue'
import OtherBusDialog from './components/OtherBusDialog.vue'
import GrossProfitFileDialog from './components/GrossProfitFileDialog.vue'
import CheckoutDialog from './components/CheckoutDialog.vue'
import { permissions, getRecentDayDate, derive } from '@/utils/common'
const BaseMutiInput = () => import('@/components/base/BaseMutiInput')
import { grossProfitClePicPages, grossProfitOtherServicePage } from '@/api/fee'
import { mapGetters } from 'vuex'
import { myMixins } from '@/mixins'
export default {
  name: 'GrossProfit',
  filters: {
    formatter(value) {
      let str = ''
      switch (value) {
        case 0:
          str = '未关账'
          break
        case 1:
          str = '部分关账'
          break
        case 2:
          str = '已关账'
          break
      }
      return str
    }
  },
  components: {
    BaseTable,
    BaseFilter,
    GrossProfitQTDialog,
    CloseBillDialog,
    GrossProfitPSDialog,
    GrossProfitFileDialog,
    CheckoutDialog,
    BaseMutiInput,
    OtherBusDialog
  },
  mixins: [myMixins],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      active: 0,
      activeCode: '',
      tableData: {
        fileds: [],
        columns: [],
        total: 0,
        showIndex: true,
        mutiCheck: true
      },
      loading: false,
      height: 0,
      filterList: {
        date: '',
        yDate: '',
        // date: ['2022-12-01', '2022-12-31'],
        companyId: '',
        closeType: 'all',
        closingAccountStatus: 'all',
        closeNo: []
      },
      isActive: false,
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,
      rowData: {},
      orderObj: {},
      selection: [],
      pagerConfig: {
        pageIndex: 1,
        pageSize: 20
      },
      closeTypeOptions: [
        {
          value: 'all',
          label: '全部'
        },
        {
          value: 0,
          label: '未关账'
        },
        {
          value: 1,
          label: '部分关账'
        },
        {
          value: 2,
          label: '已关账'
        }
      ],
      closeTypeOptions1: [
        {
          value: 'all',
          label: '全部'
        },
        {
          value: 0,
          label: '未关账'
        },
        {
          value: 1,
          label: '已关账'
        }
      ],
      referenceNumber: '',
      searchVal: '',
      total: {
        totalGrossProfitAmount: 0,
        totalPayableAmount: 0,
        totalPayableTariffAmount: 0,
        totalReceivableAmount: 0,
        totalReceivableTariffAmount: 0
      },
      exportList: ['export', 'export_b', 'export_c'], // 导出按钮的权限验证
      contrastList: ['contrast', 'contrast_b', 'contrast_c', 'contrast_d'] // 对照表按钮的权限验证
    }
  },
  computed: {
    ...mapGetters(['companyDrapdown']),
    fileds() {
      const obj = {
        0: [
          {
            filed: 'mblNo',
            label: '提单号',
            width: '250',
            isCopy: true
          },
          {
            filed: 'blNo',
            label: '分单号',
            width: '250',
            isCopy: true
          },
          {
            filed: 'containerNumber',
            label: '柜号',
            width: '250',
            isCopy: true
          },
          {
            filed: 'companyName',
            label: '客户',
            width: ''
          },
          {
            filed: 'reviewOn',
            label: '审核日期',
            width: '',
            formatter: (row) => {
              return row.reviewOn.slice(0, 10)
            },
            isSort: true
          },
          {
            filed: 'eta',
            label: 'ETA',
            width: '',
            formatter: (row) => {
              return row.eta.slice(0, 10)
            },
            isSort: true
          },
          {
            filed: 'closeType',
            label: '关账状态',
            width: '',
            isCustom: true,
            isSort: true
          },
          {
            filed: 'currency',
            label: '币制',
            width: ''
          },
          {
            filed: 'payableAmount',
            label: '应付金额',
            width: '',
            isSort: true
          },
          {
            filed: 'payableTariffAmount',
            label: '应付关税金额',
            width: '',
            isSort: true
          },
          {
            filed: 'receivableAmount',
            label: '应收金额',
            width: '',
            isSort: true
          },
          {
            filed: 'receivableTariffAmount',
            label: '应收关税金额',
            width: '',
            isSort: true
          },
          {
            filed: 'grossProfit',
            label: '毛利',
            isCustom: true,
            isSort: true
          }
        ],
        1: [
          {
            filed: 'companyName',
            label: '客户',
            width: '230'
          },
          {
            filed: 'serviceNo',
            label: '主单号',
            width: '210',
            isCopy: true
          },
          {
            filed: 'createdOn',
            label: '创建时间',
            width: '150',
            isSort: true,
            formatter: (row) =>
              row.createdOn
                ? row.createdOn.slice(0, row.createdOn.length - 3)
                : ''
          },
          {
            filed: 'otherServiceType',
            label: '业务类型',
            width: 160,
            isCustom: true,
            align: 'left'
          },
          {
            filed: 'receivableAmount',
            label: '实际应收'
          },
          {
            filed: 'payableAmount',
            label: '实际应付'
          },
          {
            filed: 'grossProfit',
            label: '毛利',
            isCustom: true,
            isSort: true
          },
          {
            filed: 'closingAccountStatus',
            label: '关账状态',
            isCustom: true,
            isSort: true
          }
        ]
      }
      return obj[this.active]
    },
    companyOptions() {
      return this.companyDrapdown
    },
    sumPayableAmount() {
      let sum = 0
      this.tableData.columns.forEach((item) => {
        sum += this.active === 0 ? +item.payableAmount : +item.totalPayable
      })
      return `${sum.toFixed(2)} ${
        this.tableData.columns[0]?.currency || 'USD'
      }`
    },
    sumReceivableAmount() {
      let sum = 0
      this.tableData.columns.forEach((item) => {
        sum +=
          this.active === 0 ? +item.receivableAmount : +item.totalReceivable
      })
      return `${sum.toFixed(2)} ${
        this.tableData.columns[0]?.currency || 'USD'
      }`
    },
    sumgrossProfit() {
      let sum = 0
      this.tableData.columns.forEach((item) => {
        sum += +item.grossProfit
      })
      return `${sum.toFixed(2)} ${
        this.tableData.columns[0]?.currency || 'USD'
      }`
    },
    newCloseBill() {
      const menuList = this.$store.getters.initRouter
      const menu = permissions(this.$route.meta.code, menuList)
      const presentTab = menu.children.find((a) => a.code === this.activeCode)
      const code = presentTab?.children?.find((a) => a.nameCH === '关账')?.code
      return code || ''
    },
    computedPermissions() {
      return function(key) {
        const menuList = this.$store.getters.initRouter
        const menu = permissions(this.$route.meta.code, menuList)
        const presentTab = menu.children.find(
          (a) => a.code === this.activeCode,
        )
        const code = presentTab?.children?.find((a) => a.nameCH === key)?.code
        return code || ''
      }
    }
  },
  created() {
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }
    this.filterList.date = getRecentDayDate()
    const menuList = this.$store.getters.initRouter
    const menu = permissions(this.$route.meta.code, menuList)
    const codeList = ['QT', 'QTYW']
    const childrenCode = menu.children.map((a) => a.code)
    this.activeName = codeList.findIndex((a) => childrenCode.includes(a))
    this.activeCode = menu.children[0].code
     this.getList(this.pagerConfig)
    // console.log('date', date)
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
    this.getList(this.pagerConfig)
  },
  methods: {
    changeType(type, code) {
      this.active = type
      this.activeCode = code
      this.selection = []
      this.handleEmpty()
    },
    handleSelectionChange(selected) {
      this.selection = selected
    },
    search() {
      if (this.filterList.search) {
       this.pagerConfig = {
        pageIndex: 1,
        pageSize: this.pagerConfig.pageSize
      }
      this.getList({
        pageIndex: 1,
        pageSize: this.pagerConfig.pageSize
      })
      }
    },
    handleEmpty() {
      this.referenceNumber = ''
      this.searchVal = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.filterList.date = getRecentDayDate()
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: this.pagerConfig.pageSize
      }
      this.getList({
        pageIndex: 1,
        pageSize: this.pagerConfig.pageSize
      })
    },
    handlePageChange(pager) {
      this.pagerConfig = {
        ...pager
      }
      this.getList(pager)
    },
    handleConfirm() {
      // if (this.filterList.search) {
      //   this.getList()
      // }
      // mousedown 早于 change 执行 所以延时  如果用click则 change后不执行代码
      setTimeout(() => {
        if (this.referenceNumber && this.referenceNumber !== '') {
          this.searchVal = this.referenceNumber.join(',')
          this.filterList.date = ''
        }
        this.$refs.popover.doClose()
        this.getList(this.pagerConfig)
      }, 0)
      // // todo 重置filter
      // this.filterList = {}
      // const param = {
      //   pageIndex: 1,
      //   pageSize: 20
      // }
      // this.pagerConfig = param
      // this.isActive = false
      // this.getList(param, {
      //   status: this.activeName !== '' ? this.activeName : undefined,
      //   subStatus: this.activeName2 !== '' ? this.activeName2 : undefined
      // })
      // this.getList(this.pagerConfig)
    },
    sortChange(orderObj) {
      if (orderObj.order) {
        this.orderObj = {
          sortField: orderObj.prop,
          sortBy: orderObj.order === 'asc' ? 0 : 1
        }
      } else {
        this.orderObj = {}
      }
      this.getList(this.pagerConfig)
    },
    async getList(pagerParams) {
      this.loading = true
      try {
        let res
        if (this.active === 0) {
          const params = {
            ...pagerParams,
            queryParam: {
              ...this.orderObj,
              ...this.formatterFilter()
            }
          }
          res = await grossProfitClePicPages(params)
          this.loading = false
          if (res.success) {
            this.tableData.columns = res.data.list
            this.tableData.total = res.data.total
            this.total = {
              totalGrossProfitAmount: res.data.totalGrossProfitAmount,
              totalPayableAmount: res.data.totalPayableAmount,
              totalPayableTariffAmount: res.data.totalPayableTariffAmount,
              totalReceivableAmount: res.data.totalReceivableAmount,
              totalReceivableTariffAmount: res.data.totalReceivableTariffAmount
            }
          } else {
            this.$message.error(res.errorMessage)
          }
        } else {
          const params = {
            ...pagerParams,
            queryParam: {
              ...this.orderObj,
              ...this.formatterFilter()
            }
          }
          res = await grossProfitOtherServicePage(params)
          this.loading = false
          if (res.success) {
            this.tableData.columns = res.data.list
            this.tableData.total = res.data.total
            this.total = {
              totalGrossProfitAmount: res.data.totalGrossProfitAmount,
              totalPayableAmount: res.data.totalPayableAmount,
              totalPayableTariffAmount: res.data.totalPayableTariffAmount,
              totalReceivableAmount: res.data.totalReceivableAmount,
              totalReceivableTariffAmount: res.data.totalReceivableTariffAmount
            }
          } else {
            this.$message.error(res.errorMessage)
          }
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    formatterFilter() {
      return {
        companyId:
          this.filterList.companyId !== ''
            ? this.filterList.companyId
            : undefined,
        search: this.searchVal ? this.searchVal : undefined,
        startDate:
          this.filterList.date && this.filterList.date !== ''
            ? this.filterList.date[0]
            : undefined,
        endDate:
          this.filterList.date && this.filterList.date !== ''
            ? this.filterList.date[1]
            : undefined,
        reviewStartDate:
          this.filterList.reviewDate && this.filterList.reviewDate !== ''
            ? this.filterList.reviewDate[0]
            : undefined,
        reviewEndDate:
          this.filterList.reviewDate && this.filterList.reviewDate !== ''
            ? this.filterList.reviewDate[1]
            : undefined,
        yStartDate:
          this.filterList.date && this.filterList.yDate !== ''
            ? this.filterList.yDate[0]
            : undefined,
        yEndDate:
          this.filterList.date && this.filterList.yDate !== ''
            ? this.filterList.yDate[1]
            : undefined,
        closeType:
          this.filterList.closeType !== 'all'
            ? this.filterList.closeType
            : undefined,
        closingAccountStatus:
          this.filterList.closingAccountStatus !== 'all'
            ? this.filterList.closingAccountStatus
            : undefined,
        closeNo: this.filterList.closeNo.length
          ? this.filterList.closeNo
          : undefined
      }
    },
    sendFilter() {
      if (
        this.filterList.companyId !== '' ||
        this.filterList.date !== '' ||
        this.filterList.yDate !== '' ||
        this.filterList.closeType !== 'all' ||
        this.filterList.closingAccountStatus !== 'all' ||
        this.filterList.closeNo.length
      ) {
        this.isActive = true
      } else {
        this.isActive = false
      }
      this.getList(this.pagerConfig)
    },
    reset() {
      this.filterList = {
        date: getRecentDayDate(),
        yDate: '',
        companyId: '',
        search: '',
        isCloseNo: 'all',
        closeType: 'all',
        closingAccountStatus: 'all',
        closeNo: []
      }
      this.isActive = false
      this.$refs.baseMutiInput1.reset()
    },
    formatterColor(closeType) {
      let obj
      switch (closeType) {
        case 0:
          obj = {
            color: '#999999',
            background: 'rgba(153, 153, 153, .1)'
          }
          break
        case 1:
          obj = {
            color: '#FEAA4F',
            background: 'rgba(254, 170, 79, .1)'
          }
          break
        case 2:
          obj = {
            color: '#35BA83',
            background: 'rgba(53, 186, 131, .1)'
          }
          break
      }
      return obj
    },
    async download() {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      elink.href = `/SystemFile/downLoadTemplate?guid=bde6809ff8814f12963aeb430b49b5f2`
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    },
    initList() {
      this.reset()
      this.getList(this.pagerConfig)
    },
    showBillingDetail(row) {
      this.rowData = row
      if (this.active === 1) {
      this.dialogVisible6 = true
      } else {
      this.dialogVisible = true
      }
    },
    psDetail(row) {
      this.rowData = row
      this.dialogVisible3 = true
    },
    exportListFile() {
      if (this.active === 1) {
        this.loading = true
        derive('/Analysis/grossProfitExportOtherService', 'post', this.formatterFilter())
        this.loading = true
      } else {
        this.dialogVisible4 = true
      }
    },
    handleFocus() {
      this.$refs.popover.doShow()
    },
    closeSearchPanel() {
      this.handleConfirm()
    }
  }
}
</script>

<style lang="less" scoped>
.view-contanier {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tabItem {
      padding: 15px 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
      box-sizing: border-box;
    }
    .active {
      color: rgb(18, 88, 188);
    }
  }
  .opt {
    display: flex;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    & > div {
      height: 30px;
      box-sizing: border-box;
      margin-right: 5px;
      border-radius: 2px;
      cursor: pointer;
    }
    .upload {
      width: 80px;
      border: 1px solid rgb(18, 88, 188);
      color: rgb(18, 88, 188);
    }
    .close {
      width: 80px;
      border: 1px solid #35ba83;
      color: #35ba83;
    }
    .contrast {
      width: 160px;
      border: 1px solid #eeeeee;
      color: #666666;
    }
    .search {
      position: relative;
      display: flex;
      width: 200px;
      margin-right: 5px;
      .searchPop {
        /deep/ .el-popover {
          z-index: 9999;
          right: 0;
        }
        .close-pop {
          position: absolute;
          top: 6px;
          right: 10px;
          cursor: pointer;
          font-size: 20px;
        }
      }
      .input-search {
        width: 166px;
        height: 30px !important;
        /deep/ .el-input__inner {
          height: 30px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      .btn-search {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 33px;
        height: 30px;
        border: 1px solid #dbe4f2;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
  }
  .data {
    width: 100%;
    height: calc(100% - 50px);
    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
    .custom-total {
      display: flex;
      position: absolute;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 50px;
      background: #f7f7f7;
      border: 1px solid #eeeeee;
      border-top: 0;
      padding-left: 17px;
      padding-right: 40px;
      box-sizing: border-box;
      .select {
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
      .total {
        margin-left: 16px;
        font-size: 14px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        color: #333333;
        span {
          color: #fe453d;
          font-weight: bold;
        }
      }
    }
    .status {
      width: 60px;
      height: 26px;
      border-radius: 4px 4px 4px 4px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      margin: 0 auto;
    }
    .green {
      background: rgba(53, 186, 131, 0.1);
      color: #35ba83;
    }
    .red {
      background: rgba(255, 116, 68, 0.1);
      color: #ff7444;
    }
    .tips {
      display: inline-block;
      width: 60px;
      height: 26px;
      background: #999999;
      border-radius: 4px 4px 4px 4px;
    }
    .otherServiceType {
      display: flex;
      .type-item {
        height: 26px;
        background: rgba(37, 151, 244, 0.1);
        border-radius: 4px 4px 4px 4px;
        padding: 5px 3px;
        box-sizing: border-box;
        font-size: 12px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color: rgb(18, 88, 188);
        & + .type-item {
          margin-left: 5px;
        }
      }
    }
    .closingAccountStatus0 {
      background: rgba(153, 153, 153, 0.1);
      color: rgba(153, 153, 153, 1);
    }
    .closingAccountStatus1 {
      background: rgba(53, 186, 131, 0.1);
      color: rgba(53, 186, 131, 1);
    }
  }
  .table-opt {
    display: flex;
    justify-content: space-around;
    span {
      margin-right: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      cursor: pointer;
    }
  }
  .footer {
    width: 100%;
    height: 50px;
    background: #f7f7f7;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    display: flex;
    justify-content: space-between;
    .selection {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 50px;
      margin-left: 20px;
    }
    .sum {
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      line-height: 50px;
    }
    .sum-item {
      margin-right: 40px;
    }
    .price {
      font-weight: bold;
      color: #fe453d;
    }
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin-left: 10px;
}
</style>
